module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticeHandsHips3.png
// module id = 2434
// module chunks = 2